<template>
  <el-col :style="{height:height,width:width}" style="position:relative" v-loading="loading"
    element-loading-text="频谱分析中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div :style="{height:height,width:width}"  id="spectrum-line"  ></div>
  </el-col>
</template>

<script>
import * as echarts from "echarts";
import { getFactorNoise} from '../../api/api';

export default {
  components: {},
  props: {
    width: {
      type: String,
      default: () => {
        return '100%'
      }
    },
    height: {
      type: String,
      default: () => {
        return '100%'
      }
    },
    projectId: {
      type: String,
      default: () => {
        return ''
      }
    },
    mn: {
      type: String,
      default: () => {
        return ''
      }
    },
    num: {
      type: Number,
      default: () => {
        return 0
      }
    },
    mode: {
      type: Number,
      default: () => {
        return 3
      }
    },
    collapsed: {
        type: Boolean,
    },
  },
  data () {
    return {
        xData:[],
        yData:[],
        title:'频谱分析',
        factorMap:new Map(),
        loading:false,
        charts:null,
        wsurl:window.configuration.wsUrlSecond,
        socket:null,
        haveData:false
    }
  },
  created () {},
  mounted () {
    this.getAnalyData(this.mn);
    this.getFactorNoise();
    var _this=this;
    window.onresize = function(){
        if(_this.charts!=null){
            _this.charts.resize();
        }
    }

    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
  },
  destroyed() {
    if (this.socket && this.socket.close !== null) {
      this.socket.close();
    }
  },
  watch: {
    'collapsed': {
      handler (val) {
        if(this.charts!=null){
            this.charts.resize();
        }
      },
      deep: true
    },
    'num': {
      handler (val) {
        this.getAnalyData(this.mn);
      },
      deep: true
    },
    'mode': {
      handler (val) {
        if(this.num!=0){
          let dataTemp={ "mode":this.mode,"state":1,"mnStr": this.mn };
          this.websocketSend(JSON.stringify(dataTemp));
        }
      },
      deep: true
    }
  },
  computed: {
    setOption () {
      let option = {
        color: ['#59a869'],
        title: { text:this.title},
        tooltip: { trigger: 'axis' },
        xAxis: { data: this.xData, name:'频率',},
        yAxis:  { type: 'value', name:'噪声值(dB)',},
        series:  {  
          type: 'bar',data: this.yData,
          label: {
          normal: {
            show: true,//开启显示
            position: 'top',//柱形上方
            textStyle: { //数值样式
              color: '#000'
            }
          }
        }
       }
      }
      return option
    }
  },
  methods: {
    // 页面关闭之前，触发提示框
    beforeunloadHandler(e) {
      if (e) {
        if (this.socket && this.socket.close !== null) {
          this.closeWsReal();
          this.socket.close();
        }
      }
    },
    getFactorNoise(){ 
      	if(this.factorMap.size>0){
					this.getNoiseSpectrum(row);
					return;
				}
       getFactorNoise({}).then((res) => {
          var factor = res.data.data;
            for (let i = 0; i < factor.length; i++) {
              this.factorMap.set(factor[i].name,factor[i].code);
              this.xData.push(factor[i].name);
            }
            this.initChart();
        });
    },
    getAnalyData(mn){
        if(mn==""){
          this.loading=false;

          if(this.num!=0){
            this.$message({
              message: "未选择设备,开启失败",
              type: 'warning'
            })
            this.$emit('select-type',"status",0);
          }
          return;
        }
        if(this.num==0){
          this.loading=false;
          this.closeWsReal();
          if (this.socket && this.socket.close !== null) {
            this.socket.close();
          }
          return;
        }
        this.websocketInit();
    },
    // 初始化表格
    initChart () {
      this.charts = echarts.init(document.getElementById("spectrum-line"))
      this.charts.setOption(this.setOption)
    },
    websocketInit: function () {
      if(this.socket!=null){
        this.socket.close();
      }
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else{
        this.loading=true;
        // 实例化socket
        this.socket = new WebSocket(this.wsurl);//ws://xxxxx 
        this.haveData=false;//未收到数据
        // 监听socket错误信息
        this.socket.onerror = this.websocketError;
        // 监听socket消息
        this.socket.onmessage = this.websocketGetMessage;
        //连接成功建立的回调方法
        this.socket.onopen = this.websocketOpen;
        this.socket.onclose = this.websocketClose;
      }
    },
    websocketClose : function(event){
      console.log("socket连接关闭");
    },
    closeWsReal(){
      let dataTemp={ "mode":this.mode, "state":0, "mnStr": this.mn };
      this.websocketSend(JSON.stringify(dataTemp));
    },
    openWsReal(){
      // {"mode": 1, "state": 1, "mnStr": "1,2,3,4"}
      // mode 1 声级计 2 频谱   state1开0关
      let dataTemp={ "mode":this.mode, "state":1, "mnStr": this.mn };
      this.websocketSend(JSON.stringify(dataTemp));
    },
    websocketOpen : function(event){
      this.openWsReal();

      var _this=this;
      var timeer;
      clearTimeout(timeer)
      timeer=setTimeout(() => {
        if(!_this.haveData&&_this.loading){
          //关闭弹窗
          _this.loading=false;
          //提醒
          _this.$message({
            message: "开启频谱分析模式失败，请确认设备是否在线",
            type: 'error'
          })
          //关闭websocket
          _this.closeWsReal();

          if (_this.socket && _this.socket.close !== null) {
            _this.socket.close();
          }
          this.$emit('select-type',"status",0);
        }
      }, 1000*10);
    },
    websocketError: function () {
      console.log("socket连接错误");
      if(this.loading){
        this.loading=false;
      }
    },
    websocketGetMessage: function (msg) {
      this.haveData=true;
      this.loading=false;
      //处理数据 msg.data
      var obj=JSON.parse(msg.data);
      if(obj.data!=undefined){
          this.yData=[];
          this.xData.forEach(element => {
              var value=obj.data[this.factorMap.get(element)];
              if(value==null) value="-";
              this.yData.push(value);
          });
          this.initChart();
          this.$emit('select-type',"time",obj.dateTime);
      }
    },
    websocketSend: function (params) {
      this.socket.send(params);
      console.log("发送数据"+params);
    },
  }
}
</script>

<style>
  .dataCord{
    width: 2rem;
    right: -1rem;
    bottom: 3rem;
  }
  .dataCord .input-item .btn{
    margin-bottom: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// SpectrumLine.vue?349b9b06